const removeFromArrayById = (array, setFunct, id) => {
    let _array = [...array];
    
    let __array = _array.filter(function(item) {
        return (item.id !== id) ? item : null;
    });
    setFunct(__array);          
}
export default removeFromArrayById;
